import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { AutoUnsubscribe, COUNTRIES, DIALOG_DEFAULT_CONFIG, DialogSize, IconNames } from '../../common';
import { Base } from '../../common/models/base.model';
import { MatDialog } from '@angular/material/dialog';
import { CountrySelectionDialogComponent } from './country-dialog/country-dialog.component';
import { without } from 'lodash';

@Component({
    selector: 'country-selection',
    templateUrl: './country-selection.component.html',
    styleUrls: ['./country-selection.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
@AutoUnsubscribe
export class CountrySelectionComponent {
  @Input() title: string;
  @Input() noEntriesFoundLabel: string;
  @Input() testId = 'country-select';
  @Input() isDisabled?: boolean;
  @Input() isDataEditable: boolean;
  @Input() set countries(countriesList: string[]) {
    this.countriesList = COUNTRIES.filter((country: Base) => countriesList?.includes(country.id));
  }

  countriesList: Base[] = [];
  iconNames = IconNames;
  @Output() listChange = new EventEmitter<Base[]>();

  constructor(private dialog: MatDialog, private cd: ChangeDetectorRef) {}

  manageCountries(): void {
    this.dialog
      .open(CountrySelectionDialogComponent, {
        data: this.countriesList,
        ...DIALOG_DEFAULT_CONFIG,
        width: DialogSize.LG,
      })
      .afterClosed()
      .subscribe(({ selected }: { selected?: Base[] }) => {
        if (selected) {
          this.countriesList = selected;
          this.listChange.emit(this.countriesList);
          this.cd.markForCheck();
        }
      });
  }
  removeCountry(country: Base): void {
    this.countriesList = [...without(this.countriesList, country)];
    this.listChange.emit(this.countriesList);
    this.cd.markForCheck();
  }
}
